import React from "react";
import underconst from "../../assets/Image/under_const.png";

export default function NotFound() {
  return (
    <div className="expensecontainer"
      style={{
        display: 'flex',
        flexDirection: 'column',   // Stack items vertically
        justifyContent: 'center',  // Center vertically
        alignItems: 'center',      // Center horizontally
        textAlign: 'center',       // Center text inside h3
      }}
    >
      <h3>
        Sorry, the page isn’t ready yet! But don’t worry—we’ll get it up and
        running soon.
      </h3>
      <div>
        <img
          src={underconst}
          alt="Not Found"
          className="not-found-image"
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </div>
    </div>
  );
}
